// Моки для проверки экранов без бэкенда (?mock=1 или 404 в dev).
const delay = (ms) => new Promise(r => setTimeout(r, ms));

export async function mockBrief(date) {
  await delay(300);
  return {
    date,
    branches: [
      { id: 1, name: 'Цех Алматы', sheets: 1840, grade1_pct: 94.2, defect_pct: 1.8, downtime_min: 35, status: 'ok', note: 'Всё идёт по плану.' },
      { id: 2, name: 'Цех Астана', sheets: 1210, grade1_pct: 88.5, defect_pct: 4.6, downtime_min: 125, status: 'warn', note: 'Простой пресса №2 из-за смены плёнки.' },
      { id: 3, name: 'Цех Шымкент', sheets: 420, grade1_pct: 71.0, defect_pct: 12.3, downtime_min: 310, status: 'bad', note: 'Много брака по плёнке, выпуск вдвое ниже плана.' },
    ],
    summary_text: 'Вчера выпущено **3470 листов**. Главная проблема — Шымкент: брак 12%, простой более 5 часов.',
    generated_at: new Date().toISOString(),
  };
}

export async function mockChat(message, conversationId) {
  await delay(1500);
  return {
    conversation_id: conversationId || 101,
    answer: `По вопросу «${message}»:\n\n- **Алматы** — 1840 листов, без замечаний\n- **Астана** — простой 2 ч 05 мин\n- **Шымкент** — брак 12,3%\n\nГлавная причина — смена плёнки и остановки пресса.`,
    links: [{ title: 'Открыть подробно', url: '/director' }],
    caveats: ['Данные за сегодня могут быть неполными: смена ещё идёт.'],
  };
}

export async function mockConversations() {
  await delay(200);
  return [
    { id: 101, title: 'Что было вчера?', updated_at: new Date(Date.now() - 3600e3).toISOString(), created_at: new Date(Date.now() - 3600e3).toISOString() },
    { id: 100, title: 'Почему простой в Астане?', updated_at: new Date(Date.now() - 86400e3).toISOString(), created_at: new Date(Date.now() - 86400e3).toISOString() },
  ];
}

export async function mockConversation(id) {
  await delay(200);
  const t = new Date(Date.now() - 3600e3).toISOString();
  return {
    id, title: 'Что было вчера?', created_at: t,
    messages: [
      { role: 'user', text: 'Что было вчера?', created_at: t },
      { role: 'assistant', text: 'Вчера выпущено **3470 листов**.\n\n- Алматы: 1840\n- Астана: 1210\n- Шымкент: 420', created_at: t },
    ],
  };
}
